import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Alert from './Alert';
import CurrentUserContext from '../contexts/CurrentUserContext';
import './Login.css';

function Login() {
  const { setCurrentUser } = useContext(CurrentUserContext);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [apiError, setApiError] = useState('');

  const navigate = useNavigate();

  const login = async (event) => {
    event.preventDefault();
    try {
      const resutl = await axios.post('/api/auth/login', {
        username,
        password,
      });
      setApiError('');
      setCurrentUser(resutl.data);
      if (resutl.data?.access === 'associate') {
        navigate('/orders');
      } else {
        navigate('/');
      }
    } catch (err) {
      console.log(err);
      setApiError(err?.response?.data?.error || 'Unknown error');
    }
  };

  return (
    <div className="login-component">
      <Alert visible={!!apiError} type="error">
        <p>There was an error logging in.</p>
        <p>{ apiError }</p>
        <p>Please try again.</p>
      </Alert>
      <h2>Log In</h2>
      <form onSubmit={login}>
        <div>
          <label htmlFor="username">
            Username:
            <input
              type="text"
              id="username"
              name="username"
              value={username}
              autoComplete="username"
              required
              onChange={(event) => setUsername(event.target.value)}
            />
          </label>
        </div>
        <label htmlFor="password">
          Password:
          <input
            type="password"
            id="password"
            name="password"
            value={password}
            autoComplete="current-password"
            required
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>
        <div />
        <button type="submit">Log In</button>
      </form>
    </div>
  );
}

export default Login;
